// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"521":"75da2b2d","829":"5b163bda"}[chunkId] + ".chunk.css";
};